<template>
    <div class="content">
        <div  :class="{'header-container': true, on: showMore}">
            <ul id="headLine" class="headLine">
                <li v-if="isLogin" class="avatar-container"><span class="avatar"></span><p>{{name}}</p></li>
                <li @click="navigateTo('login')" v-if="isLogin===false" :class="language==='en-US' ? 'on' : ''"><span v-text="language=='zh-CN' ? '登' : 'L'"></span><p v-text="language=='zh-CN' ? '录' : 'og In'"></p></li>
                <li @click="loginOut" v-if="isLogin" :class="language==='en-US' ? 'on' : ''"><span v-text="language=='zh-CN' ? '退' : 'L'"></span><p v-text="language=='zh-CN' ? '出' : 'og out'"></p></li>
                <li v-show="dailyEvent_ZH || dailyEvent_EN" @click="navigateToPDF" :class="language==='en-US' ? 'on' : ''"><span v-text="language=='zh-CN' ? '赛' : 'E'"></span><p v-text="language=='zh-CN' ? '事日程' : 'vent schedule'"></p></li>
                <li :class="language==='en-US' ? 'on' : ''" @click="changeLanguage"><span v-text="language=='zh-CN' ? 'E' : 'C'"></span><p v-text="language=='zh-CN' ? 'N' : 'N'"></p></li>
            </ul>
            <input type="text" id="hiddenUrl" v-model="copyUrl">
            <div class="mainBg">
                <img v-show="logoImg" @click="navigateTo('index')" class="title" :src="logoImg">
                <div class="search-container">
                    <div class="searchTool-container">
                        <!-- <div @click="voiceSearch" :class="language==='en-US' ? 'voice-container on' : 'voice-container'">
                            <img src="../assets/voiceIconBlue.png">
                            <p v-text="$t('m.voiceSearch')"></p>
                        </div>
                        <div @click="picSearch" :class="language==='en-US' ? 'pic-container on' : 'pic-container'">
                            <img src="../assets/picIconBlue.png">
                            <p v-text="$t('m.picSearch')"></p>
                        </div>
                        <div @click="faceSearch" :class="language==='en-US' ? 'face-container on' : 'face-container'">
                            <img src="../assets/faceIconBlue.png">
                            <p v-text="$t('m.faceSearch')"></p>
                        </div> -->
                    </div>
                    <div class="searchInput-container">
                        <input @keyup.enter="searchKeyWord" @focus="isFocus=true;" @blur="leaveFocus" v-model="search" type="text">
                        <div class="delIcon">
                          <img @click="delSearch" v-if="isFocus&&!isNull" src="../assets/delOn.png">
                        </div>
                        <div @click="searchKeyWord" class="searchIcon"></div>
                    </div>
                </div>
            </div>
            <div class="video-container">
              <div class="leftVideo-container">
                <div class="leftTopVideo-container">
                  <p class="title">{{videoDetail.title}}</p>
                  <div class="share-container">
                    <p class="date">{{videoDetail.date}}</p>
                    <div @click="copy" class="share">
                      <div class="img"></div>
                      <p v-text="$t('m.share')"></p>
                    </div>
                  </div>
                  <div class="videoPlayer-container">
                    <div id="mse"></div>
                    <!-- <video-player class="video-player vjs-custom-skin"
                      v-if="playerOptions.sources && playerOptions.sources[0] && playerOptions.sources[0].src"
                      ref="videoPlayer"
                      :playsinline="true"
                      :options="playerOptions"
                      @ready="videoReady"
                      @playing="timePlaying"
                      @pause="timeWaiting"
                    ></video-player> -->
                  </div>
                  <div class="videoInfo-container">
                    <div :class="language==='en-US' ? 'videoInfo on' : 'videoInfo'">
                      <p>{{$t('m.videoSize')}} {{videoDetail.pixel}}</p>
                      <p>{{$t('m.duration')}} {{videoDetail.time}}</p>
                      <p>{{$t('m.codeRate')}} {{videoDetail.rate}}</p>
                      <p>{{$t('m.size')}} {{videoDetail.size}}</p>
                      <p>{{$t('m.format')}} {{videoDetail.extend}}</p>
                    </div>
                    <div class="videoBtn">
                      <!-- <p v-if="isLogin&&videoCategory!='1'&&videoCategory!='2'" @click="sendQuickEdit" :class="language==='en-US' ? ' on' : ''" v-text="$t('m.sendQuickCode')"></p> -->
                      <p v-if="isLogin" @click="downLoad" :class="language==='en-US' ? ' on' : ''" v-text="$t('m.videoDownload')"></p>
                      <div v-if="showTF" class="downLoadBox-container">
                        <p @click="showTF=!showTF" class="close"></p>
                        <p v-text="$t('m.videoDownload')"></p>
                        <div v-show="videoDetail.low_url">
                          <p v-text="$t('m.download2point5M')"></p>
                          <span @click="createDownload(videoDetail.low_url)" v-text="$t('m.downLoad')"></span>
                          <!-- <span @click="download25MVideo(0)" v-text="$t('m.downLoad')"></span> -->
                        </div>
                        <div v-show="videoDetail.high_url">
                          <p v-text="$t('m.download25M')"></p>
                          <span @click="createDownload(videoDetail.high_url)" v-text="$t('m.downLoad')"></span>
                          <!-- <span @click="download25MVideo(1)" v-text="$t('m.downLoad')"></span> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="isLogin==false&&language==='zh-CN'" class="unLogin-container">
                    请<p @click="navigateTo('login')">登录</p>官方账号，获取更多视频操作权限。
                </div>
                <div v-if="isLogin==false&&language==='en-US'" class="unLogin-container">
                    Please <p @click="navigateTo('login')">log in</p> to the official account to get more video operation rights.
                </div>
                <div v-if="isLogin" class="leftBottomVideo-container">
                  <!-- <div @click="showMore=true" v-if="isLogin&&showMore===false&&myVideo.length>2" class="loadMore" v-text="$t('m.loadMore')"></div> -->
                  <!-- <div @click="showMore=false" v-if="isLogin&&showMore&&myVideo.length>2" class="loadMore" v-text="$t('m.hideMore')"> -->
                  <div @click="showMore=true" v-if="isLogin&&showMore===false&&myVideo.length>2" class="loadMore down">
                    <i></i>
                    <p v-text="$t('m.loadMore')"></p>
                  </div>
                  <div @click="showMore=false" v-if="isLogin&&showMore&&myVideo.length>2" class="loadMore up">
                    <i></i>
                    <p v-text="$t('m.hideMore')"></p>
                  </div>
                  <p v-text="$t('m.interceptingClips')"></p>
                  <div class="spliteTime">
                    <div class="startTime-container">
                      <p v-text="$t('m.startTime')" @click="setStartTimePoint"></p>
                      <input v-model="startTime" type="text">
                    </div>
                    <span class="timeIcon"></span>
                    <div class="endTime-container">
                      <p v-text="$t('m.endTime')" @click="setEndTimePoint"></p>
                      <input v-model="endTime" type="text">
                    </div>
                    <div @click="clipeBox=true" :class="language==='en-US' ? 'spliteBtn on' : 'spliteBtn'" v-text="$t('m.confirmInterception')"></div>
                  </div>
                  <div v-if="clipeBox" class="clipeBox">
                    <div>
                      <p v-text="$t('m.interceptionTime')"></p>
                      <span>{{startTimeSave}} -- {{endTimeSave}}</span>
                    </div>
                    <div>
                      <p v-text="$t('m.interceptNaming')"></p>
                      <input v-model="clipeTitle" type="text">
                    </div>
                    <div class="clipeBtn">
                      <p @click="clipeBox=false" class="cancel" v-text="$t('m.cancel')"></p>
                      <p @click="clipe" class="submit" v-text="$t('m.submit')"></p>
                    </div>
                  </div>
                  <div class="line"></div>
                  <div class="myVideo-container">
                    <p v-text="$t('m.myVideo')"></p>
                    <ul v-if="hasMyVideo" class="myVideo">
                      <li v-for="item in sliceMyVideo" v-if="showMore===false">
                        <img :src="item.cover">
                        <div class="myVideoInfo-container">
                          <div class="myVideoInfo">
                            <p v-if="item.title" class="title">{{item.title}}</p>
                            <div class="info">
                              <p v-if="item.pixel">{{$t('m.videoSize')}} {{item.pixel}}</p>
                              <p v-if="item.cuttime">{{$t('m.interceptionTime')}}  {{item.cuttime}}</p>
                              <p v-if="item.time">{{$t('m.duration')}} {{item.time}}</p>
                              <p v-if="item.rate">{{$t('m.codeRate')}} {{item.rate}}</p>
                              <p v-if="item.size">{{$t('m.size')}} {{item.size}}</p>
                              <p v-if="item.extend">{{$t('m.format')}} {{item.extend}}</p>
                            </div>
                          </div>
                          <div :class="language==='en-US' ? 'myVideoBtn on' : 'myVideoBtn'">
                            <p v-if="!item.extend"></p>
                            <span v-if="!item.extend" v-text="$t('m.transcoding')"></span>
                            <span @click="downLoadMyVideo(item.mediaId)" v-if="item.extend" v-text="$t('m.downLoad')"></span>
                          </div>
                        </div>
                      </li>
                      <li v-for="item in myVideo" v-if="showMore">
                        <img :src="item.cover">
                        <div class="myVideoInfo-container">
                          <div class="myVideoInfo">
                            <p v-if="item.title" class="title">{{item.title}}</p>
                            <div class="info">
                              <p v-if="item.pixel">{{$t('m.videoSize')}} {{item.pixel}}</p>
                              <p v-if="item.cuttime">{{$t('m.interceptionTime')}}  {{item.cuttime}}</p>
                              <p v-if="item.time">{{$t('m.duration')}} {{item.time}}</p>
                              <p v-if="item.rate">{{$t('m.codeRate')}} {{item.rate}}</p>
                              <p v-if="item.size">{{$t('m.size')}} {{item.size}}</p>
                              <p v-if="item.extend">{{$t('m.format')}} {{item.extend}}</p>
                            </div>
                          </div>
                          <div :class="language==='en-US' ? 'myVideoBtn on' : 'myVideoBtn'">
                            <p v-if="!item.extend"></p>
                            <span v-if="!item.extend" v-text="$t('m.transcoding')"></span>
                            <span @click="downLoadMyVideo(item.mediaId)" v-if="item.extend" v-text="$t('m.downLoad')"></span>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <p class="hasMyVideo" v-if="hasMyVideo==false" v-text="$t('m.noMyVideo')"></p>
                  </div>
                </div>
              </div>
              <!-- <div class="rightVideo-container">
                <ul :class="language==='en-US' ? 'on' : ''">
                  <li @click="rightType='Catalogue';downloadType=2" v-text="$t('m.autoCata')" :class="language==='en-US' ? rightType==='Catalogue' ? 'en on' : 'en' : rightType==='Catalogue' ? 'on' : ''"></li>
                  <p :class="language==='en-US' ? 'en' : ''" v-if="isLogin" @click="downLoadInfo" v-text="$t('m.downLoad')"></p>
                </ul>
                <div class="info">
                  <ul class="info-container">
                    <li v-if="videoRight[rightType].length>0" v-for="item in videoRight[rightType]" @click="seekTime(item.time)">
                      <div class="line"></div>
                      <div class="date">
                        {{item.time}}
                      </div>
                      <div class="content">
                        <span style="margin-right: 0.05rem">{{item.content}}</span>
                        <span v-if="rightType==='Catalogue'">{{item.describe}}</span>
                      </div>
                      <div class="point">
                      </div>
                    </li>
                    <p v-if="showCatalogue==false&&rightType=='Catalogue'" v-text="$t('m.noCatalogue')"></p>
                    <p v-if="showlogkeeper==false&&rightType=='logkeeper'" v-text="$t('m.nologkeeper')"></p>
                  </ul>
                </div>
              </div> -->
            </div>
        </div>
        <div id="hiddenUrl1" style="position: absolute;top: -98765px;left: -98765px;">{{copyUrl}}</div>
    </div>
</template>
<script>
import bus from '../bus'
// import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'
import 'videojs-contrib-hls.js/src/videojs.hlsjs'
import { setTimeout } from 'timers';
export default {
    data() {
        return {
            copyUrl: '',
            name: '',
            uid: '',
            unid: '',
            search: '',
            dailyEvent_ZH: '',
            dailyEvent_EN: '',
            clipeTitle: '',
            role: '',
            logoImg: '',
            language: 'zh-CN',
            player1: null,
            startTime: null,
            endTime: null,
            startTimeSave: null,
            endTimeSave: null,
            saveStartTime: null,
            saveEndTime: null,
            setSecond: null,
            calMyvideo: null,
            clipeBox: false,
            isLogin: false,
            mousedown: false,
            mousedown1: false,
            showMore: false,
            isSetStartTimePoint: false,
            isSetEndTimePoint: false,
            isLoad: false,
            isNull: true,
            isFocus: false,
            showTF: false,
            has25M: false,
            hasMyVideo: false,
            index: 1,
            downloadType: 0,
            playerOptions: {},
            videoDetail: {},
            videoRight: {},
            myVideo: [],
            sliceMyVideo: [],
            rightType: 'Catalogue',
            showCatalogue: true,
            showlogkeeper: true,
            videoCategory: ''
        }
    },
    watch: {
        language(to) { // 监听语言变化改变cookie
            this.$i18n.locale = to;
            $.cookie('language',to);
        },
        isLogin(to) { // 监听登录状态变化跳转相应页面显示提示语
          if(!to){
            if(this.language==='zh-CN'){
              this.$message({
                type: 'warning',
                message: '请登录官方账号，获取更多视频操作权限。'
              })
            }else{
              this.$message({
                type: 'warning',
                message: 'Please log in to the official account to get more video operation rights.'
              })
            }
            this.$router.push({
              name: 'login',
              params: {
                sourceUrl: encodeURIComponent('videoDetail'),
                id: this.$route.params.id
              }
            })
          }
        },
        clipeBox(to) { // 监听剪辑确认弹框打开关闭状态
          if(to) {
            var startTime = this.formatHMStoS(this.startTime);
            var endTime = this.formatHMStoS(this.endTime);
            this.showTF = false;
            if(startTime!=undefined&&startTime!=null&&startTime!=''){
              if(startTime<0){
                startTime = 0
              }else if(startTime>this.player1.duration){
                startTime = this.player1.duration
              }
            }else{
              startTime = 0;
            }
            if(endTime!=undefined&&endTime!=null&&endTime!=''){
              if(endTime<0){
                endTime = 0
              }else if(endTime>this.player1.duration){
                endTime = this.player1.duration
              }
            }else{
              endTime = this.player1.duration;
            }

            // 判断剪辑打点时间开始时间是否小于结束时间，如开始时间大于结束时间时间互换
            if(startTime > endTime){
              if(endTime==0){
                this.startTimeSave = '00:00:00';
              }else{
                this.startTimeSave = this.formatSeconds(endTime);
              }
              if(startTime==0){
                this.endTimeSave = '00:00:00';
              }else{
                this.endTimeSave = this.formatSeconds(startTime);
              }
            }else{
              if(startTime==0){
                this.startTimeSave = '00:00:00';
              }else{
                this.startTimeSave = this.formatSeconds(startTime);
              }
              if(endTime==0){
                this.endTimeSave = '00:00:00';
              }else{
                this.endTimeSave = this.formatSeconds(endTime);
              }
            }
          }
        },
        search(to) {
            if(to.length>0){
                this.isNull = false;
                this.isFocus = true;
            }else{
                this.isNull = true;
            }
        }
    },
    methods: {
      leaveFocus() {
        var that = this;
        setTimeout(function(){
            that.isFocus = false;
        },150)
      },
      delSearch() {
        this.search = '';
        $('.searchInput-container input').focus();
      },
      getInfo() { // 获取用户信息
        var that = this;
        require('../utils.js').requestWithToken({
            url: require('../config.json').urlBase + require('../config.json').url.user.info,
            success: function (res) {
                if(res.code!='10000'){
                    localStorage.removeItem('uid');
                    localStorage.removeItem('unid');
                    localStorage.removeItem('name');
                    localStorage.removeItem('role');
                    that.isLogin = false;
                    that.role = '';
                }
            },
            error: function () {
                if(that.language==='zh-CN'){
                    that.$message({
                        type: 'error',
                        message: '网络错误'
                    })
                }else{
                    that.$message({
                        type: 'error',
                        message: 'Network Error'
                    })
                }
            }
        })
      },
      timePlaying() { // 视频播放事件
        var that = this;
        if(!this.isSetStartTimePoint){
          this.getSecond();
        }
        if(!this.isSetEndTimePoint){
          this.getSecond1();
        }
      },
      timeWaiting() { // 视频暂停事件
        clearInterval(this.setSecond)
        clearInterval(this.setSecond1)
      },
      getSecond() { // 开始时间点打点定时器
        var that = this;
        if(this.setSecond!=null){
          clearInterval(this.setSecond);
          this.setSecond = null;
        }
        this.setSecond = setInterval(() => {
          var currentTime = parseInt(that.player1.currentTime);
           if(currentTime==0){
              that.startTime = '00:00:00';
              that.saveStartTime = '00:00:00';
            }else{
              that.startTime = that.formatSeconds(currentTime);
              that.saveStartTime = that.formatSeconds(currentTime);
            }
        });
      },
      getSecond1() { // 结束时间点打点定时器
        var that = this;
        if(this.setSecond1!=null){
          clearInterval(this.setSecond1);
          this.setSecond1 = null;
        }
        this.setSecond1 = setInterval(() => {
          var currentTime = parseInt(that.player1.currentTime);
          if(currentTime==0){
            that.endTime = '00:00:00';
            that.saveEndTime = '00:00:00';
          }else{
            that.endTime = that.formatSeconds(currentTime);
            that.saveEndTime = that.formatSeconds(currentTime);
          }
        });
      },
      copy () { // PC端/移动端复制功能
        var isPc = this.IsPC();
        if(isPc){
          $('#hiddenUrl').select()
          document.execCommand("copy"); // 执行浏览器复制命令
          $('#hiddenUrl').blur();
          if(this.language==='zh-CN'){
            this.$message({
              type: 'success',
              message: '复制成功'
            })
          }else{
            this.$message({
              type: 'success',
              message: 'Copied to clipboard'
            })
          }
        }else{
          const range = document.createRange();
          range.selectNode(document.getElementById('hiddenUrl1'));
          const selection = window.getSelection();
          if(selection.rangeCount > 0) selection.removeAllRanges();
          selection.addRange(range);
          document.execCommand('copy');
          if(this.language==='zh-CN'){
            this.$message({
              type: 'success',
              message: '复制成功'
            })
          }else{
            this.$message({
              type: 'success',
              message: 'Copied to clipboard'
            })
          }
        }
      },
      searchKeyWord() { // 搜索关键词
        var that = this;
        var keyWord = that.search;
        keyWord = encodeURIComponent(keyWord)
        this.$router.push({
            name: 'searchList',
            params: {
                keyWord: keyWord
            }
        })
      },
      sendQuickEdit() { // 发起快编功能
        var that = this;
        require('../utils.js').requestWithToken({
          url: require('../config.json').urlBase + require('../config.json').url.detail.quickedit,
          data: {
            id: that.$route.params.id
          },
          success: function(res) {
            if(res.code=='10000'){
              if(that.language==='zh-CN'){
                that.$message({
                  type: 'success',
                  message: res.result.msg.zh_msg
                })
              }else{
                that.$message({
                  type: 'success',
                  message: res.result.msg.en_msg
                })
              }
            }else{
              if(that.language==='zh-CN'){
                that.$message({
                  type: 'warning',
                  message: res.error.message.zh_msg
                })
              }else{
                that.$message({
                  type: 'warning',
                  message: res.error.message.en_msg
                })
              }
            }
          },
          error: function() {
            if(that.language==='zh-CN'){
              that.$message({
                  type: 'error',
                  message: '网络错误'
              })
            }else{
              that.$message({
                  type: 'error',
                  message: 'Network Error'
              })
            }
          }
        })
      },
      seekTime(time) { // 跳转时间点
        var time1 = this.formatHMStoS(time);
        this.player1.currentTime = time1;
        this.player1.play();
      },
      IsPC() { // 判断是否是PC端
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
                  "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
      },
      downLoad() { // PC端/移动端下载功能
        var that = this;
        var isPc = this.IsPC();
        require('../utils.js').requestWithToken({
            url: require('../config.json').urlBase + require('../config.json').url.user.info,
            success: function (res) {
                if(res.code!='10000'){
                    localStorage.removeItem('uid');
                    localStorage.removeItem('unid');
                    localStorage.removeItem('name');
                    localStorage.removeItem('role');
                    that.isLogin = false;
                }else if(res.code=='10000'){
                  if(isPc){
                    if(that.role!=4){
                      var body = document.body
                      var jsonrpc1 = "2.0";
                      var timetamp1 = (new Date()).valueOf();
                      var nonce1 = Math.random().toString(36).substr(2);
                      var key = "zPVAVhZxHS2b9fAskODfZk28pYsNW8sd";
                      var uid1 = localStorage.getItem('uid');
                      var unid1 = localStorage.getItem('unid');
                      var string1 = "";
                      string1 = "jsonrpc=" + jsonrpc1+ "&nonce=" + nonce1 + "&timetamp=" + timetamp1 + "&uid=" + uid1 + "&unid=" + unid1 + key;
                      var sign1 = $.md5(string1);
                      var form = document.createElement('form')
                      form.method = 'post'
                      form.action = require('../config.json').urlBase + require('../config.json').url.detail.download
                      var jsonrpc = document.createElement('input')
                      jsonrpc.type = 'hidden'
                      jsonrpc.name = 'jsonrpc'
                      jsonrpc.value = jsonrpc1
                      var uid = document.createElement('input')
                      uid.type = 'hidden'
                      uid.name = 'uid'
                      uid.value = uid1
                      var unid = document.createElement('input')
                      unid.type = 'hidden'
                      unid.name = 'unid'
                      unid.value = unid1
                      var timetamp = document.createElement('input')
                      timetamp.type = 'hidden'
                      timetamp.name = 'timetamp'
                      timetamp.value = timetamp1
                      var nonce = document.createElement('input')
                      nonce.type = 'hidden'
                      nonce.name = 'nonce'
                      nonce.value = nonce1
                      var sign = document.createElement('input')
                      sign.type = 'hidden'
                      sign.name = 'sign'
                      sign.value = sign1
                      var id = document.createElement('input')
                      id.type = 'hidden'
                      id.name = 'id'
                      id.value = that.$route.params.id
                      form.appendChild(jsonrpc)
                      form.appendChild(uid)
                      form.appendChild(unid)
                      form.appendChild(timetamp)
                      form.appendChild(nonce)
                      form.appendChild(sign)
                      form.appendChild(id)
                      body.appendChild(form)
                      form.submit()
                      body.removeChild(form)
                    }else{
                      if(that.has25M){
                        that.showTF = true;
                      }else{
                        var body = document.body
                        var jsonrpc1 = "2.0";
                        var timetamp1 = (new Date()).valueOf();
                        var nonce1 = Math.random().toString(36).substr(2);
                        var key = "zPVAVhZxHS2b9fAskODfZk28pYsNW8sd";
                        var uid1 = localStorage.getItem('uid');
                        var unid1 = localStorage.getItem('unid');
                        var string1 = "";
                        string1 = "jsonrpc=" + jsonrpc1+ "&nonce=" + nonce1 + "&timetamp=" + timetamp1 + "&uid=" + uid1 + "&unid=" + unid1 + key;
                        var sign1 = $.md5(string1);
                        var form = document.createElement('form')
                        form.method = 'post'
                        form.action = require('../config.json').urlBase + require('../config.json').url.detail.download
                        var jsonrpc = document.createElement('input')
                        jsonrpc.type = 'hidden'
                        jsonrpc.name = 'jsonrpc'
                        jsonrpc.value = jsonrpc1
                        var uid = document.createElement('input')
                        uid.type = 'hidden'
                        uid.name = 'uid'
                        uid.value = uid1
                        var unid = document.createElement('input')
                        unid.type = 'hidden'
                        unid.name = 'unid'
                        unid.value = unid1
                        var timetamp = document.createElement('input')
                        timetamp.type = 'hidden'
                        timetamp.name = 'timetamp'
                        timetamp.value = timetamp1
                        var nonce = document.createElement('input')
                        nonce.type = 'hidden'
                        nonce.name = 'nonce'
                        nonce.value = nonce1
                        var sign = document.createElement('input')
                        sign.type = 'hidden'
                        sign.name = 'sign'
                        sign.value = sign1
                        var id = document.createElement('input')
                        id.type = 'hidden'
                        id.name = 'id'
                        id.value = that.$route.params.id
                        form.appendChild(jsonrpc)
                        form.appendChild(uid)
                        form.appendChild(unid)
                        form.appendChild(timetamp)
                        form.appendChild(nonce)
                        form.appendChild(sign)
                        form.appendChild(id)
                        body.appendChild(form)
                        form.submit()
                        body.removeChild(form)
                      }
                    }
                  }else{ // 如移动端点击下载按钮提示提示语
                    if(that.language==='zh-CN'){
                      that.$message({
                        type: 'warning',
                        message: '建议使用电脑下载视频'
                      })
                    }else{
                      that.$message({
                        type: 'warning',
                        message: 'It is recommended to use a computer to download videos'
                      })
                    }
                  }
                }
            },
            error: function () {
                if(that.language==='zh-CN'){
                    that.$message({
                        type: 'error',
                        message: '网络错误'
                    })
                }else{
                    that.$message({
                        type: 'error',
                        message: 'Network Error'
                    })
                }
            }
        })
      },
      downLoadInfo() { // 下载场记信息/自动编目
        var that = this;
        var isPc = this.IsPC();
        require('../utils.js').requestWithToken({
            url: require('../config.json').urlBase + require('../config.json').url.user.info,
            success: function (res) {
                if(res.code!='10000'){
                    localStorage.removeItem('uid');
                    localStorage.removeItem('unid');
                    localStorage.removeItem('name');
                    localStorage.removeItem('role');
                    that.isLogin = false;
                }else if(res.code=='10000'){
                  if(isPc){
                    var body = document.body
                    var jsonrpc1 = "2.0";
                    var timetamp1 = (new Date()).valueOf();
                    var nonce1 = Math.random().toString(36).substr(2);
                    var key = "zPVAVhZxHS2b9fAskODfZk28pYsNW8sd";
                    var uid1 = localStorage.getItem('uid');
                    var unid1 = localStorage.getItem('unid');
                    var string1 = "";
                    string1 = "jsonrpc=" + jsonrpc1+ "&nonce=" + nonce1 + "&timetamp=" + timetamp1 + "&uid=" + uid1 + "&unid=" + unid1 + key;
                    var sign1 = $.md5(string1);
                    var form = document.createElement('form')
                    form.method = 'post'
                    form.action = require('../config.json').urlBase + require('../config.json').url.detail.logodownload
                    var jsonrpc = document.createElement('input')
                    jsonrpc.type = 'hidden'
                    jsonrpc.name = 'jsonrpc'
                    jsonrpc.value = jsonrpc1
                    var uid = document.createElement('input')
                    uid.type = 'hidden'
                    uid.name = 'uid'
                    uid.value = uid1
                    var unid = document.createElement('input')
                    unid.type = 'hidden'
                    unid.name = 'unid'
                    unid.value = unid1
                    var timetamp = document.createElement('input')
                    timetamp.type = 'hidden'
                    timetamp.name = 'timetamp'
                    timetamp.value = timetamp1
                    var nonce = document.createElement('input')
                    nonce.type = 'hidden'
                    nonce.name = 'nonce'
                    nonce.value = nonce1
                    var sign = document.createElement('input')
                    sign.type = 'hidden'
                    sign.name = 'sign'
                    sign.value = sign1
                    var type = document.createElement('input')
                    type.type = 'hidden'
                    type.name = 'type'
                    type.value = that.downloadType
                    var id = document.createElement('input')
                    id.type = 'hidden'
                    id.name = 'id'
                    id.value = that.$route.params.id
                    form.appendChild(jsonrpc)
                    form.appendChild(uid)
                    form.appendChild(unid)
                    form.appendChild(timetamp)
                    form.appendChild(nonce)
                    form.appendChild(sign)
                    form.appendChild(type)
                    form.appendChild(id)
                    body.appendChild(form)
                    form.submit()
                    body.removeChild(form)
                  }else{ // 如移动端点击下载按钮提示提示语
                    if(that.language==='zh-CN'){
                      that.$message({
                        type: 'warning',
                        message: '建议使用电脑下载视频'
                      })
                    }else{
                      that.$message({
                        type: 'warning',
                        message: 'It is recommended to use a computer to download videos'
                      })
                    }
                  }
                }
            },
            error: function () {
                if(that.language==='zh-CN'){
                    that.$message({
                        type: 'error',
                        message: '网络错误'
                    })
                }else{
                    that.$message({
                        type: 'error',
                        message: 'Network Error'
                    })
                }
            }
        })
      },
      downLoadMyVideo(id1) { // 下载截取视频
        var that = this;
        var isPc = this.IsPC();
        require('../utils.js').requestWithToken({
            url: require('../config.json').urlBase + require('../config.json').url.user.info,
            success: function (res) {
                if(res.code!='10000'){
                    localStorage.removeItem('uid');
                    localStorage.removeItem('unid');
                    localStorage.removeItem('name');
                    localStorage.removeItem('role');
                    that.isLogin = false;
                }else if(res.code=='10000'){
                  if(isPc){
                    var body = document.body
                    var jsonrpc1 = "2.0";
                    var timetamp1 = (new Date()).valueOf();
                    var nonce1 = Math.random().toString(36).substr(2);
                    var key = "zPVAVhZxHS2b9fAskODfZk28pYsNW8sd";
                    var uid1 = localStorage.getItem('uid');
                    var unid1 = localStorage.getItem('unid');
                    var string1 = "";
                    string1 = "jsonrpc=" + jsonrpc1+ "&nonce=" + nonce1 + "&timetamp=" + timetamp1 + "&uid=" + uid1 + "&unid=" + unid1 + key;
                    var sign1 = $.md5(string1);
                    var form = document.createElement('form')
                    form.method = 'post'
                    form.action = require('../config.json').urlBase + require('../config.json').url.detail.download
                    var jsonrpc = document.createElement('input')
                    jsonrpc.type = 'hidden'
                    jsonrpc.name = 'jsonrpc'
                    jsonrpc.value = jsonrpc1
                    var uid = document.createElement('input')
                    uid.type = 'hidden'
                    uid.name = 'uid'
                    uid.value = uid1
                    var unid = document.createElement('input')
                    unid.type = 'hidden'
                    unid.name = 'unid'
                    unid.value = unid1
                    var timetamp = document.createElement('input')
                    timetamp.type = 'hidden'
                    timetamp.name = 'timetamp'
                    timetamp.value = timetamp1
                    var nonce = document.createElement('input')
                    nonce.type = 'hidden'
                    nonce.name = 'nonce'
                    nonce.value = nonce1
                    var sign = document.createElement('input')
                    sign.type = 'hidden'
                    sign.name = 'sign'
                    sign.value = sign1
                    var id = document.createElement('input')
                    id.type = 'hidden'
                    id.name = 'id'
                    id.value = id1
                    form.appendChild(jsonrpc)
                    form.appendChild(uid)
                    form.appendChild(unid)
                    form.appendChild(timetamp)
                    form.appendChild(nonce)
                    form.appendChild(sign)
                    form.appendChild(id)
                    body.appendChild(form)
                    form.submit()
                    body.removeChild(form)
                  }else{
                    if(that.language==='zh-CN'){
                      that.$message({
                        type: 'warning',
                        message: '建议使用电脑下载视频'
                      })
                    }else{
                      that.$message({
                        type: 'warning',
                        message: 'It is recommended to use a computer to download videos'
                      })
                    }
                  }
                }
            },
            error: function () {
                if(that.language==='zh-CN'){
                    that.$message({
                        type: 'error',
                        message: '网络错误'
                    })
                }else{
                    that.$message({
                        type: 'error',
                        message: 'Network Error'
                    })
                }
            }
        })
      },
      createDownload(url) { 
        const link = document.createElement('a');
        link.href = url;
        link.download = '';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      download25MVideo(is25m1) {
        var that = this;
        var isPc = this.IsPC();
        require('../utils.js').requestWithToken({
            url: require('../config.json').urlBase + require('../config.json').url.user.info,
            success: function (res) {
                if(res.code!='10000'){
                    localStorage.removeItem('uid');
                    localStorage.removeItem('unid');
                    localStorage.removeItem('name');
                    localStorage.removeItem('role');
                    that.isLogin = false;
                }else if(res.code=='10000'){
                    that.showTF = false;
                    if(isPc){
                      var body = document.body
                      var jsonrpc1 = "2.0";
                      var timetamp1 = (new Date()).valueOf();
                      var nonce1 = Math.random().toString(36).substr(2);
                      var key = "zPVAVhZxHS2b9fAskODfZk28pYsNW8sd";
                      var uid1 = localStorage.getItem('uid');
                      var unid1 = localStorage.getItem('unid');
                      var string1 = "";
                      string1 = "jsonrpc=" + jsonrpc1+ "&nonce=" + nonce1 + "&timetamp=" + timetamp1 + "&uid=" + uid1 + "&unid=" + unid1 + key;
                      var sign1 = $.md5(string1);
                      var form = document.createElement('form')
                      form.method = 'post'
                      form.action = require('../config.json').urlBase + require('../config.json').url.detail.download
                      var jsonrpc = document.createElement('input')
                      jsonrpc.type = 'hidden'
                      jsonrpc.name = 'jsonrpc'
                      jsonrpc.value = jsonrpc1
                      var uid = document.createElement('input')
                      uid.type = 'hidden'
                      uid.name = 'uid'
                      uid.value = uid1
                      var unid = document.createElement('input')
                      unid.type = 'hidden'
                      unid.name = 'unid'
                      unid.value = unid1
                      var timetamp = document.createElement('input')
                      timetamp.type = 'hidden'
                      timetamp.name = 'timetamp'
                      timetamp.value = timetamp1
                      var nonce = document.createElement('input')
                      nonce.type = 'hidden'
                      nonce.name = 'nonce'
                      nonce.value = nonce1
                      var sign = document.createElement('input')
                      sign.type = 'hidden'
                      sign.name = 'sign'
                      sign.value = sign1
                      var id = document.createElement('input')
                      id.type = 'hidden'
                      id.name = 'id'
                      id.value = that.$route.params.id
                      var is25m = document.createElement('input')
                      is25m.type = 'hidden'
                      is25m.name = 'is25m'
                      is25m.value = is25m1
                      form.appendChild(jsonrpc)
                      form.appendChild(uid)
                      form.appendChild(unid)
                      form.appendChild(timetamp)
                      form.appendChild(nonce)
                      form.appendChild(sign)
                      form.appendChild(id)
                      form.appendChild(is25m)
                      body.appendChild(form)
                      form.submit()
                      body.removeChild(form)
                    }else{ // 如移动端点击下载按钮提示提示语
                      if(that.language==='zh-CN'){
                        that.$message({
                          type: 'warning',
                          message: '建议使用电脑下载视频'
                        })
                      }else{
                        that.$message({
                          type: 'warning',
                          message: 'It is recommended to use a computer to download videos'
                        })
                      }
                    }
                }
            },
            error: function () {
                if(that.language==='zh-CN'){
                    that.$message({
                        type: 'error',
                        message: '网络错误'
                    })
                }else{
                    that.$message({
                        type: 'error',
                        message: 'Network Error'
                    })
                }
            }
        })
      },
      clipe() { // 剪辑功能
        var that = this;
        var startTime = this.formatHMStoS(this.startTimeSave);
        var endTime = this.formatHMStoS(this.endTimeSave);
        require('../utils.js').requestWithToken({
          url: require('../config.json').urlBase + require('../config.json').url.detail.cutout,
          data: {
            id: that.$route.params.id,
            title: that.clipeTitle,
            in: startTime,
            out: endTime
          },
          success: function(res) {
            if(res.code=='10000'){
              if(that.language==='zh-CN'){
                that.$message({
                  type: 'success',
                  message: res.result.msg.zh_msg
                })
              }else{
                that.$message({
                  type: 'success',
                  message: res.result.msg.en_msg
                })
              }
              that.clipeBox = false;
              that.getMyVideoDetail();
            }else{
              if(that.language==='zh-CN'){
                that.$message({
                  type: 'warning',
                  message: res.error.message.zh_msg
                })
              }else{
                that.$message({
                  type: 'warning',
                  message: res.error.message.en_msg
                })
              }
            }
          },
          error: function() {
            if(that.language==='zh-CN'){
              that.$message({
                  type: 'error',
                  message: '网络错误'
              })
            }else{
              that.$message({
                  type: 'error',
                  message: 'Network Error'
              })
            }
          }
        })
      },
      formatSeconds(value) { // hh:mm:ss 格式化时间
        var hh = parseInt(value/3600);
        if(hh<10) hh = "0" + hh;
        var mm = parseInt((value-hh*3600)/60);
        if(mm<10) mm = "0" + mm;
        var ss = parseInt((value-hh*3600)%60);
        if(ss<10) ss = "0" + ss;
        var length = hh + ":" + mm + ":" + ss;
        if(value>0){
          return length;
        }else{
          return "NaN";
        }
      },
      formatHMStoS(value){ // 格式时间转秒数
         var h = parseInt(value.split(':')[0]);
         var m = parseInt(value.split(":")[1]);
         var s = parseInt(value.split(":")[2]);
         var ss= h*60*60+m*60+s;
         return ss;
      },
      getConfig() { // 获取通用信息
          var that = this;
          require('../utils.js').requestWithToken({
              url: require('../config.json').urlBase + require('../config.json').url.user.getConfig,
              success: function(res) {
                if(res.code==='10000'){
                  that.dailyEvent_ZH = res.result.dailyevents_url.zh_url;
                  that.dailyEvent_EN = res.result.dailyevents_url.en_url;
                  that.logoImg = res.result.logo;
                }else{
                  if(that.language==='zh-CN'){
                    that.$message({
                      type: 'warning',
                      message: res.error.message.zh_msg
                    })
                  }else{
                    that.$message({
                      type: 'warning',
                      message: res.error.message.en_msg
                    })
                  }
                }
              },
              error: function() {
                if(that.language==='zh-CN'){
                    that.$message({
                        type: 'error',
                        message: '网络错误'
                    })
                }else{
                    that.$message({
                        type: 'error',
                        message: 'Network Error'
                    })
                }
              }
          })
      },
      getMyvideo(){ // 获取我的视频内容
        var that = this;
        require('../utils.js').requestWithToken({
          url: require('../config.json').urlBase + require('../config.json').url.detail.detail,
          data: {
            id: that.$route.params.id
          },
          success: function(res) {
            if(res.code==='10000'){
              that.myVideo = res.result.myvideo;
              if(that.myVideo.length>0){
                that.hasMyVideo = true;
              }else{
                that.hasMyVideo = false;
              }
              that.sliceMyVideo = res.result.myvideo.slice(0,2);
              that.isLoad = false;
              if(that.myVideo.length>0){
                that.myVideo.forEach(function(val){
                  if(val.rate==''||val.rate==undefined||val.rate==null){
                    that.isLoad = true;
                  }
                })
                if(that.isLoad){
                  clearInterval(that.calMyvideo);
                  that.calMyvideo = setInterval(() => {
                    that.getMyvideo();
                  }, 5000);
                }else{
                  clearInterval(that.calMyvideo);
                }
              }
            }
          },
          error: function() {
          }
        })
      },
      getVideoDetail(id) { // 获取视频详情
        var that = this;
        if(that.player){
          that.player.destroy()
        }
        require('../utils.js').requestWithToken({
          url: require('../config.json').urlBase + require('../config.json').url.detail.detail,
          data: {
            id: id
          },
          success: function(res) {
            if(res.code==='10000'){
              let player = null;
              if(res.result.video.extend == 'MP4'){
                player = new Player({
                  id: 'mse',
                  lang: that.language=='en-US' ? 'en' : 'zh-cn',
                  url: res.result.video.mp4,
                  autoplay: true,
                  playsinline: true,
                  height: '100%',
                  width: '100%',
                  // ignores: ['time','progress']
                });
              }else{
                player = new HlsPlayer({
                  id: 'mse',
                  lang: that.language=='en-US' ? 'en' : 'zh-cn',
                  url: res.result.video.m3u8,
                  isLive: false,
                  autoplay: true,
                  playsinline: true,
                  height: '100%',
                  width: '100%',
                  // ignores: ['time','progress']
                });
              }
              
              that.player = player
              that.player1 = player
              // var playerOptions = {
              //   //playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
              //   autoplay: false, //如果true,浏览器准备好时开始回放。
              //   muted: false, // 默认情况下将会消除任何音频。
              //   loop: false, // 导致视频一结束就重新开始。
              //   preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
              //   language: 'zh-CN',
              //   aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
              //   fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
              //   controlBar: {
              //     volumePanel: {
              //       inline: false //默认是true,横着的
              //     }
              //   },
              //   sources: [{
              //       src: res.result.video.m3u8 //你的m3u8地址（必填）
              //   }],
              //   poster: res.result.video.cover, //你的封面地址
              //   width: document.documentElement.clientWidth,
              //   notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
              //   //  controlBar: {
              //   //   timeDivider: true,
              //   //   durationDisplay: true,
              //   //   remainingTimeDisplay: false,
              //   //   fullscreenToggle: true //全屏按钮
              //   //  }
              // }
              // that.playerOptions = playerOptions;
              that.videoDetail = res.result.video;
              that.videoCategory = res.result.video.category;
              that.videoRight = res.result.right;
              if(res.result.right['Catalogue'].length>0){
                that.showCatalogue = true;
              }else{
                that.showCatalogue = false;
              }
              if(res.result.right['logkeeper'].length>0){
                that.showlogkeeper = true;
              }else{
                that.showlogkeeper = false;
              }
              that.startTime = '00:00:00';
              that.endTime = res.result.video.time;
              that.myVideo = res.result.myvideo;
              if(that.myVideo.length>0){
                that.hasMyVideo = true;
              }else{
                that.hasMyVideo = false;
              }
              that.has25M = res.result.video.is25m;
              that.sliceMyVideo = res.result.myvideo.slice(0,2);
              that.isLoad = false;
              if(that.myVideo.length>0){
                that.myVideo.forEach(function(val){
                  if(val.rate==''||val.rate==undefined||val.rate==null){
                    that.isLoad = true;
                  }
                })
                if(that.isLoad){
                  setTimeout(() => {
                    that.getMyvideo();
                  }, 5000);
                }
              }

              setTimeout(function(){
                that.changeVideoStyle();
              })
            }else{
              if(that.language==='zh-CN'){
                that.$message({
                  type: 'warning',
                  message: res.error.message.zh_msg
                })
              }else{
                that.$message({
                  type: 'warning',
                  message: res.error.message.en_msg
                })
              }
              that.$router.go(-1)
            }
          },
          error: function() {
            if(that.language==='zh-CN'){
              that.$message({
                  type: 'error',
                  message: '网络错误'
              })
            }else{
              that.$message({
                  type: 'error',
                  message: 'Network Error'
              })
            }
          }
        })
      },
      getMyVideoDetail() { // 获取我的视频详情
        var that = this;
        require('../utils.js').requestWithToken({
          url: require('../config.json').urlBase + require('../config.json').url.detail.detail,
          data: {
            id: that.$route.params.id
          },
          success: function(res) {
            if(res.code==='10000'){
              that.videoRight = res.result.right;
              that.myVideo = res.result.myvideo;
              that.sliceMyVideo = res.result.myvideo.slice(0,2);
              that.isLoad = false;
              if(that.myVideo.length>0){
                that.myVideo.forEach(function(val){
                  if(val.rate==''||val.rate==undefined||val.rate==null){
                    that.isLoad = true;
                  }
                })
                if(that.isLoad){
                  setTimeout(() => {
                    that.getMyvideo();
                  }, 5000);
                }
              }
            }else{
              if(that.language==='zh-CN'){
                that.$message({
                  type: 'warning',
                  message: res.error.message.zh_msg
                })
              }else{
                that.$message({
                  type: 'warning',
                  message: res.error.message.en_msg
                })
              }
            }
          },
          error: function() {
            if(that.language==='zh-CN'){
                that.$message({
                    type: 'error',
                    message: '网络错误'
                })
            }else{
                that.$message({
                    type: 'error',
                    message: 'Network Error'
                })
            }
          }
        })
      },
      navigateTo(res) { // 跳转
        if(res==='login'){
          this.$router.push({
            name: 'login',
            params: {
              sourceUrl: encodeURIComponent('searchList')
            }
          })
        }else{
          this.$router.push({
            name: res
          })
        }
      },
      navigateToPDF() { //跳转PDF页面
          if(this.language==='zh-CN'){
              window.open(this.dailyEvent_ZH)
              // window.location.href = this.dailyEvent_ZH
          }else{
              window.open(this.dailyEvent_EN)
              // window.location.href = this.dailyEvent_EN
          }
      },
      voiceSearch() {
            bus.$emit('voiceSearch');
        },
      picSearch() {
          bus.$emit('picSearch');
      },
      faceSearch() {
          bus.$emit('faceSearch');
      },
      setStartTimePoint() { // 设置开始时间点
        // console.log(this.player.duration)
        // return false;
        var that = this;
        clearInterval(this.setSecond);
        this.isSetStartTimePoint = true;
        if(this.startTime==this.saveStartTime){
          var currentTime = parseInt(that.player.currentTime);
          if(currentTime==0){
            that.startTime = '00:00:00';
            that.saveStartTime = '00:00:00';
          }else{
            that.startTime = that.formatSeconds(currentTime);
            that.saveStartTime = that.formatSeconds(currentTime);
          }
          if(isNaN(this.formatHMStoS(this.startTime))){
            this.startTime = '00:00:00';
            var left = 0;
            $('.timePoint-container .startPoint').css('left',left);
            $('.timePoint-container .startPoint').addClass('on');
          }else{
            if(this.formatHMStoS(this.startTime)<0){
              this.startTime = '00:00:00';
              var left = 0;
              $('.timePoint-container .startPoint').css('left',left);
              $('.timePoint-container .startPoint').addClass('on');
            }else{
              var left = this.formatHMStoS(this.startTime)/this.player.duration;
              left = left*100;
              left = left.toFixed(2)+'%';
              $('.timePoint-container .startPoint').css('left',left);
              $('.timePoint-container .startPoint').addClass('on');
            }
          }
          if(this.isSetStartTimePoint&&this.isSetEndTimePoint){
            var line = parseFloat($('.timePoint-container').width());
            var left = parseFloat($('.timePoint-container .startPoint').css('left'));
            var right = parseFloat($('.timePoint-container .endPoint').css('left'));
            left = ((left/line)*100).toFixed(2) + '%';
            right = ((right/line)*100).toFixed(2) + '%';
            if(parseFloat(right)>parseFloat(left)){
              var width = (parseFloat(right) - parseFloat(left))+'%';
              $('.timePoint-container .startEndLine').css({
                left: left,
                width: width
              })
            }else{
              var width = (parseFloat(left) - parseFloat(right))+'%';
              $('.timePoint-container .startEndLine').css({
                left: right,
                width: width
              })
            }
          }
        }else{
          if(isNaN(this.formatHMStoS(this.startTime))){
            this.startTime = '00:00:00';
            var left = 0;
            $('.timePoint-container .startPoint').css('left',left);
            $('.timePoint-container .startPoint').addClass('on');
          }else{
            if(this.formatHMStoS(this.startTime)<0){
              this.startTime = '00:00:00';
              var left = 0;
              $('.timePoint-container .startPoint').css('left',left);
              $('.timePoint-container .startPoint').addClass('on');
            }else{
              var left = this.formatHMStoS(this.startTime)/this.player.duration;
              left = left*100;
              left = left.toFixed(2)+'%';
              $('.timePoint-container .startPoint').css('left',left);
              $('.timePoint-container .startPoint').addClass('on');
            }
          }
          if(this.isSetStartTimePoint&&this.isSetEndTimePoint){
            var line = parseFloat($('.timePoint-container').width());
            var left = parseFloat($('.timePoint-container .startPoint').css('left'));
            var right = parseFloat($('.timePoint-container .endPoint').css('left'));
            left = ((left/line)*100).toFixed(2) + '%';
            right = ((right/line)*100).toFixed(2) + '%';
            if(parseFloat(right)>parseFloat(left)){
              var width = (parseFloat(right) - parseFloat(left))+'%';
              $('.timePoint-container .startEndLine').css({
                left: left,
                width: width
              })
            }else{
              var width = (parseFloat(left) - parseFloat(right))+'%';
              $('.timePoint-container .startEndLine').css({
                left: right,
                width: width
              })
            }
          }
        }
      },
      setEndTimePoint() { // 设置结束时间点
        var that = this;
        this.isSetEndTimePoint = true;
        clearInterval(this.setSecond1);
        if(this.endTime==this.saveEndTime){
          var currentTime = parseInt(that.player.currentTime);
          if(currentTime==0){
            that.endTime = '00:00:00';
            that.saveEndTime = '00:00:00';
          }else{
            that.endTime = that.formatSeconds(currentTime);
            that.saveEndTime = that.formatSeconds(currentTime);
          }
          if(isNaN(this.formatHMStoS(this.endTime))){
            this.endTime = this.formatSeconds(this.player.duration);
            var left = '100%';
            $('.timePoint-container .endPoint').css('left',left);
            $('.timePoint-container .endPoint').addClass('on');
          }else{
            if(this.formatHMStoS(this.endTime)<parseInt(this.player.duration)){
              var left = this.formatHMStoS(this.endTime)/this.player.duration;
              left = left*100;
              left = left.toFixed(2)+'%';
              $('.timePoint-container .endPoint').css('left',left);
              $('.timePoint-container .endPoint').addClass('on');
            }else if(this.formatHMStoS(this.endTime)==parseInt(this.player.duration)){
              var left = '100%';
              $('.timePoint-container .endPoint').css('left',left);
              $('.timePoint-container .endPoint').addClass('on');
            }else{
              this.endTime = this.formatSeconds(this.player.duration);
              var left = '100%';
              $('.timePoint-container .endPoint').css('left',left);
              $('.timePoint-container .endPoint').addClass('on');
            }
          }
          if(this.isSetStartTimePoint&&this.isSetEndTimePoint){
            var line = parseFloat($('.timePoint-container').width());
            var left = parseFloat($('.timePoint-container .startPoint').css('left'));
            var right = parseFloat($('.timePoint-container .endPoint').css('left'));
            left = ((left/line)*100).toFixed(2) + '%';
            right = ((right/line)*100).toFixed(2) + '%';
            if(parseFloat(right)>parseFloat(left)){
              var width = (parseFloat(right) - parseFloat(left))+'%';
              $('.timePoint-container .startEndLine').css({
                left: left,
                width: width
              })
            }else{
              var width = (parseFloat(left) - parseFloat(right))+'%';
              $('.timePoint-container .startEndLine').css({
                left: right,
                width: width
              })
            }
          }
        }else{
          if(isNaN(this.formatHMStoS(this.endTime))){
            this.endTime = this.formatSeconds(this.player.duration);
            var left = '100%';
            $('.timePoint-container .endPoint').css('left',left);
            $('.timePoint-container .endPoint').addClass('on');
          }else{
            if(this.formatHMStoS(this.endTime)<parseInt(this.player.duration)){
              var left = this.formatHMStoS(this.endTime)/this.player.duration;
              left = left*100;
              left = left.toFixed(2)+'%';
              $('.timePoint-container .endPoint').css('left',left);
              $('.timePoint-container .endPoint').addClass('on');
            }else if(this.formatHMStoS(this.endTime)==parseInt(this.player.duration)){
              var left = '100%';
              $('.timePoint-container .endPoint').css('left',left);
              $('.timePoint-container .endPoint').addClass('on');
            }else{
              this.endTime = this.formatSeconds(this.player.duration);
              var left = '100%';
              $('.timePoint-container .endPoint').css('left',left);
              $('.timePoint-container .endPoint').addClass('on');
            }
          }
          if(this.isSetStartTimePoint&&this.isSetEndTimePoint){
            var line = parseFloat($('.timePoint-container').width());
            var left = parseFloat($('.timePoint-container .startPoint').css('left'));
            var right = parseFloat($('.timePoint-container .endPoint').css('left'));
            left = ((left/line)*100).toFixed(2) + '%';
            right = ((right/line)*100).toFixed(2) + '%';
            if(parseFloat(right)>parseFloat(left)){
              var width = (parseFloat(right) - parseFloat(left))+'%';
              $('.timePoint-container .startEndLine').css({
                left: left,
                width: width
              })
            }else{
              var width = (parseFloat(left) - parseFloat(right))+'%';
              $('.timePoint-container .startEndLine').css({
                left: right,
                width: width
              })
            }
          }
        }
      },
      videoReady(player) {
        this.player1 = player
      },
      mousemove(e) {
        $('.block').css('left',e.pageX+'px');
      },
      changeLanguage() { // 修改当前页面语言
          var language = this.language;
          if(language==='zh-CN'){
              this.language = 'en-US'
          }else{
              this.language = 'zh-CN'
          }
      },
      changeVideoStyle() { // 修改当前播放器样式
        var that = this;
        $('.vjs-time-control.vjs-time-divider').remove();
        $('.vjs-remaining-time.vjs-time-control.vjs-control').remove()
        $('.vjs-play-progress.vjs-slider-bar .vjs-time-tooltip').remove()
        var rightTime = $('.vjs-duration.vjs-time-control.vjs-control')
        var volumnBtn = $('.vjs-volume-panel.vjs-control.vjs-volume-panel-vertical')
        rightTime.remove();
        rightTime.appendTo($('.vjs-progress-control.vjs-control'))
        var html = '<div class="timePoint-container"><div class="startPoint"></div><div class="endPoint"></div><div class="startEndLine"></div></div>'
        // $('.vjs-progress-holder').append(html)
        $('.xgplayer-progress-outer').append(html)
        $('.startPoint').on('mousedown',function (e) {
          console.log(123)
          that.mousedown = true
        })
        $('.endPoint').on('mousedown',function (e) {
          that.mousedown1 = true
        })
        $(document).on('mousemove',function (e) {
          if(that.mousedown){
            // console.log(e)
            var totalLength = $('.timePoint-container').width();
            var left = $('.xgplayer-progress-point').css('left');
            // console.log($('.xgplayer-progress-point').css('left'),$('.xgplayer-progress-point').width()/2)
            left = (((parseFloat(left)+parseFloat($('.xgplayer-progress-point').width()/2))/parseFloat(totalLength))*100).toFixed(2) + '%';
            var right = $('.endPoint').css('left');
            right = ((parseFloat(right)/parseFloat(totalLength))*100).toFixed(2) + '%';
            if(parseFloat(right)>parseFloat(left)){
              var width = (parseFloat(right)-parseFloat(left))+'%';
              $('.startEndLine').css({
                left: left,
                width: width
              })
            }else{
              var width = (parseFloat(left)-parseFloat(right))+'%';
              $('.startEndLine').css({
                left: right,
                width: width
              })
            }
            $('.startPoint').css('left',left);
            var startTime = that.formatSeconds(parseInt(that.player1.currentTime));
            if(parseInt(that.player1.currentTime)<=0){
              startTime = '00:00:00';
            }
            if(parseInt(that.player1.currentTime)>that.player1.duration){
              startTime = that.formatSeconds(parseInt(that.player1.duration));
            }
            that.startTime = startTime;
            that.saveStartTime = startTime;
          }
          if(that.mousedown1){
            var totalLength = $('.timePoint-container').width();
            var left = $('.xgplayer-progress-point').css('left');
            left = (((parseFloat(left)+parseFloat($('.xgplayer-progress-point').width()/2))/parseFloat(totalLength))*100).toFixed(2) + '%';
            var right = $('.startPoint').css('left');
            right = ((parseFloat(right)/parseFloat(totalLength))*100).toFixed(2) + '%';
            if(parseFloat(left)>parseFloat(right)){
              var width = (parseFloat(left)-parseFloat(right))+'%';
              $('.startEndLine').css({
                left: right,
                width: width
              })
            }else{
              var width = (parseFloat(right)-parseFloat(left))+'%';
              $('.startEndLine').css({
                left: left,
                width: width
              })
            }
            $('.endPoint').css('left',left);
            var endTime = that.formatSeconds(parseInt(that.player1.currentTime));
            if(parseInt(that.player1.currentTime)>that.player1.duration){
              endTime = that.formatSeconds(parseInt(that.player1.duration));
            }
            if(parseInt(that.player1.currentTime)<=0){
              endTime = '00:00:00';
            }
            that.endTime = endTime;
            that.saveEndTime = endTime;
          }
        })
        $(document).mouseup(function(event){//鼠标释放
          if(that.mousedown){
            that.mousedown = false
            var startTime = that.formatSeconds(parseInt(that.player1.currentTime));
            if(parseInt(that.player1.currentTime)<=0){
              startTime = '00:00:00';
            }
            if(parseInt(that.player1.currentTime)>that.player1.duration){
              startTime = that.formatSeconds(parseInt(that.player1.duration));
            }
            that.startTime = startTime;
            that.saveStartTime = startTime;
          }
          if(that.mousedown1){
            that.mousedown1 = false
            var endTime = that.formatSeconds(parseInt(that.player1.currentTime));
            if(parseInt(that.player1.currentTime)>that.player1.duration){
              endTime = that.formatSeconds(parseInt(that.player1.duration));
            }
            if(parseInt(that.player1.currentTime)<=0){
              endTime = '00:00:00';
            }
            that.endTime = endTime;
            that.saveEndTime = endTime;
          }
        })
      },
      loginOut() { // 退出登录
        var that = this;
        this.getInfo();
        var uid = localStorage.getItem('uid');
        var unid = localStorage.getItem('unid');
        var name = localStorage.getItem('name');
        var role = localStorage.getItem('role');
        if(uid!=''&&uid!=null&&uid!=undefined&&unid!=''&&unid!=null&&unid!=undefined){
            require('../utils.js').requestWithToken({
              url: require('../config.json').urlBase + require('../config.json').url.user.loginout,
              data: {
                uid: this.uid,
                unid: this.unid
              },
              success: function(res) {
                if(res.code==='10000'){
                    that.isLogin = false;
                    that.name = '';
                    that.uid = '';
                    that.unid = '';
                    localStorage.removeItem('name');
                    localStorage.removeItem('uid');
                    localStorage.removeItem('unid');
                    localStorage.removeItem('role');
                    if(that.language==='zh-CN'){
                        that.$message({
                            type: 'success',
                            message: '退出成功'
                        })
                    }else{
                        that.$message({
                            type: 'success',
                            message: 'log out successfully'
                        })
                    }
                }else{
                    if(that.language==='zh-CN'){
                        that.$message({
                            type: 'warning',
                            message: res.error.message.zh_msg
                        })
                    }else{
                        that.$message({
                            type: 'warning',
                            message: res.error.message.en_msg
                        })
                    }
                }
              },
              error: function() {
                  if(that.language==='zh-CN'){
                      that.$message({
                          type: 'error',
                          message: '网络错误'
                      })
                  }else{
                      that.$message({
                          type: 'error',
                          message: 'Network Error'
                      })
                  }
              }
            })
        }else{
          if(that.language==='zh-CN'){
              that.$message({
                  type: 'success',
                  message: '退出成功'
              })
          }else{
              that.$message({
                  type: 'success',
                  message: 'log out successfully'
              })
          }
        }
      }
    },
    beforeDestroy() {
        // clearInterval(this.setSecond)
        // clearInterval(this.setSecond1)
        // clearInterval(this.calMyvideo);
    },
    destroyed() {
      // 离开页面清除页面定时器
      clearInterval(this.setSecond);
      clearInterval(this.setSecond1);
      clearInterval(this.calMyvideo);
    },
    // computed: {
    //     player() {
    //         return this.$refs.videoPlayer.player
    //     }
    // },
    mounted() {
      var that = this;
      setTimeout(function(){
        $('#app').css({
          "height": "auto"
        })
      })
      $('.content-container').css({
          "padding-bottom": "0rem",
          "background": "#FFF"
      })
    },
    created() {
      var that = this;
      var id = this.$route.params.id;
      if(id==''||id==null||id==undefined){
        this.$router.push({
          name: 'searchList'
        })
        return false;
      }
      // 获取用户个人信息
      this.language = this.$i18n.locale;
      this.getInfo();
      var uid = localStorage.getItem('uid');
      var unid = localStorage.getItem('unid');
      var name = localStorage.getItem('name');
      var role = localStorage.getItem('role');
      if(uid!=''&&uid!=undefined&&uid!=null&&unid!=''&&unid!=undefined&&unid!=null&&name!=''&&name!=undefined&&name!=null){
          this.name = name;
          this.uid = uid;
          this.unid = unid;
          this.role = role;
          this.isLogin = true;
      }
      if(this.isLogin==false){
        this.$router.push({
          name: 'searchList'
        })
      }else{
        this.copyUrl = window.location.href;
        this.getVideoDetail(id);
        this.getConfig();
        bus.$on('search',function(e){
          that.search = e.search;
        })
      }
    }
}
</script>
<style scoped>
    .header-container {
        position: relative;
        width: 20.08rem;
        min-height: 23.39rem;
        background: url('../assets/searchListBg.png') no-repeat;
        background-position: top right;
        background-size: 20.08rem 23.39rem;
        background-color: #FFF;
        box-sizing: border-box;

        &.on {
          margin-bottom: 1.2rem;
        }
    }
    .header-container .mainBg {
        overflow: hidden;
        user-select: none;
    }
    .header-container .mainBg .title {
        float: left;
        width: 6.4rem;
        height: 0.8rem;
        margin: 0.99rem 0 0 0.64rem;
        cursor: pointer;
    }
    .header-container .mainBg .search-container {
        width: 11.6rem;
        float: right;
        margin-right: 0.64rem;
        margin-top: 1.02rem;
    }
    .header-container .mainBg .search-container .searchTool-container {
        overflow: hidden;
        height: 0.48rem;
        display: flex;
        align-items: center;
    }
    .header-container .mainBg .search-container .searchTool-container > div {
        display: flex;
        align-items: center;
        float: left;
        height: 0.48rem;
        font-size: 0.32rem;
        margin-left: 1.2rem;
        cursor: pointer;
    }
    .header-container .mainBg .search-container .searchTool-container > div:hover {
        height: 0.48rem;
        font-size: 0.36rem;
        margin-left: 1.04rem;
        cursor: pointer;
    }
    .header-container .mainBg .search-container .searchTool-container > div.on {
        margin-left: 1.3rem;
    }
    .header-container .mainBg .search-container .searchTool-container > div.on p {
        font-size: 0.28rem;
    }
    .header-container .mainBg .search-container .searchTool-container > div.on:hover p {
        font-size: 0.32rem;
    }
    .header-container .mainBg .search-container .searchTool-container > div.voice-container img {
        width: 0.4rem;
        height: 0.48rem;
    }
    .header-container .mainBg .search-container .searchTool-container > div.pic-container img {
        width: 0.49rem;
        height: 0.47rem;
    }
    .header-container .mainBg .search-container .searchTool-container > div.face-container img {
        width: 0.42rem;
        height: 0.48rem;
    }
    .header-container .mainBg .search-container .searchTool-container > div img {
        float: left;
        margin-right: 0.16rem;
    }
    .header-container .mainBg .search-container .searchTool-container > div p {
        float: left;
        color: #1e69fe;
    }
    .header-container .mainBg .search-container .searchInput-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 11.6rem;
        height: 0.8rem;
        background: #FFF;
        border: 0.02rem solid #1e69fe;
        border-radius: 6px;
        box-sizing: border-box;
        margin-top: 0.2rem;
    }
    .header-container .mainBg .search-container .searchInput-container input {
        width: 100%;
        height: 0.6rem;
        padding: 0 0.18rem;
        font-size: 0.36rem;
        color: #1e69fe;
        border: none;
        outline: none;
        box-sizing: border-box;
    }
    .header-container .mainBg .search-container .searchInput-container input:focus + .searchIcon {
        width: 0.94rem;
        height: 0.6rem;
        background: url('../assets/searchIconBlueOn.png') no-repeat;
        background-size: 0.46rem 0.46rem;
        background-position: center;
        border-left: 0.02rem solid #cfddfd;
        box-sizing: border-box;
    }
    .header-container .mainBg .search-container .searchInput-container input:focus + .delIcon + .searchIcon {
        width: 0.94rem;
        height: 0.6rem;
        background: url('../assets/searchIconBlueOn.png') no-repeat;
        background-size: 0.46rem 0.46rem;
        background-position: center;
        border-left: 0.02rem solid #cfddfd;
        box-sizing: border-box;
    }
    .header-container .mainBg .search-container .searchInput-container > .delIcon {
        position: relative;
        width: 0.3rem;
        height: 0.3rem;
        margin: 0 0.2rem 0 0.1rem;
        user-select: none;
        cursor: pointer;
    }
    .header-container .mainBg .search-container .searchInput-container > .delIcon img {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 0.3rem;
        height: 0.3rem;
    }
    .header-container .mainBg .search-container .searchInput-container .searchIcon {
        width: 0.94rem;
        height: 0.6rem;
        background: url('../assets/searchIconBlue.png') no-repeat;
        background-size: 0.46rem 0.46rem;
        background-position: center;
        border-left: 0.02rem solid #cfddfd;
        box-sizing: border-box;
        cursor: pointer;
    }
    .header-container .headLine {
        position: absolute;
        top: 0.16rem;
        right: 0.6rem;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        user-select: none;
    }
    .header-container .headLine li {
        position: relative;
        z-index: 2;
        display: flex;
        height: 0.36rem;
        flex-direction: row;
        align-items: baseline;
        font-size: 0.24rem;
        color: #10163e;
        text-align: center;
        cursor: pointer;
        margin-left: 0.5rem;
    }
    .header-container .headLine li::before {
        position: absolute;
        top: 50%;
        left: -0.05rem;
        z-index: -1;
        margin-top: -0.18rem;
        display: block;
        content: '';
        width: 0.36rem;
        height: 0.36rem;
        background: #FFF;
        border-radius: 50%;
    }
    .header-container .headLine li.on::before {
        position: absolute;
        top: 50%;
        left: -0.1rem;
        z-index: -1;
        margin-top: -0.18rem;
        display: block;
        content: '';
        width: 0.36rem;
        height: 0.36rem;
        background: #FFF;
        border-radius: 50%;
    }
    .header-container .headLine li.avatar-container {
        display: flex;
        align-items: center;
    }
    .header-container .headLine li:hover {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 0.28rem;
        color: #1e69fe;
        text-align: center;
        cursor: pointer;
    }
    .header-container .headLine li span {
        display: inline-block;
        /* width: 0.36rem;
        height: 0.36rem; */
        line-height: 0.36rem;
        font-size: 0.28rem;
        color: #1e69fe;
        /* border-radius: 50%; */
        /* background: #FFF; */
    }
    .header-container .headLine li p {
        line-height: 0.36rem;
    }
    .header-container .headLine li span.avatar {
        width: 0.36rem;
        height: 0.36rem;
        border-radius: 50%;
        background: #FFF;
        background: url('../assets/avatarIcon.png') no-repeat;
        background-size: 0.22rem 0.27rem;
        background-position: center;
        background-color: #FFF;
    }
    .header-container .headLine li:nth-last-of-type(1)::after {
        display: block;
        content: '';
        width: 0.09rem;
        height: 0.13rem;
        margin-left: 0.07rem;
        background: url('../assets/leftArrow.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }
    .header-container .headLine li:nth-last-of-type(1):hover::after {
        display: block;
        content: '';
        width: 0.09rem;
        height: 0.13rem;
        margin-left: 0.07rem;
        background: url('../assets/leftArrowOn.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }
    .header-container .video-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 19.2rem;
        min-height: 18.4rem;
        margin-left: 0.44rem;
        margin-top: 0.5rem;
    }
    .header-container .video-container .leftVideo-container {
      /*width: 14.4rem;*/
      width: 100%;
      min-height: 18.4rem;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container {
      width: 100%;
      min-height: 10.48rem;
      margin-bottom: 0.2rem;
      background: #FFF;
      box-shadow: 0rem 0.25rem 0.5rem 0px rgba(0,17,101,0.06);
      padding: 0.2rem 0.4rem;
      border: 1px solid #F5F5F6;
      box-sizing: border-box;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .title {
      font-size: 0.4rem;
      color: #10163e;
      line-height: 0.6rem;
      min-height: 1.2rem;
      word-break: break-all;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .share-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 0.06rem;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .share-container .share {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 0.24rem;
      color: #1e69fe;
      cursor: pointer;
      user-select: none;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .share-container .share:hover {
      color: #10163e;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .share-container .share .img {
      width: 0.24rem;
      height: 0.28rem;
      background: url('../assets/shareIcon.png') no-repeat;
      background-position: center;
      background-size: 100%;
      margin-right: 0.1rem;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .share-container .share:hover .img {
      width: 0.24rem;
      height: 0.28rem;
      background: url('../assets/shareIconOn.png') no-repeat;
      background-position: center;
      background-size: 100%;
      margin-right: 0.1rem;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .date {
      font-size: 0.24rem;
      color: #848a9d;
      line-height: 0.48rem;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoPlayer-container {
      width: 13.6rem;
      height: 7.58rem;
      border-radius: 6px;
      box-sizing: border-box;
      overflow: hidden;
      margin: 0 auto;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 0.6rem;
      margin-top: 0.19rem;
      font-size: 0.24rem;
      color: #848a9d;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoInfo {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoInfo.on {
      width: 7rem;
      font-size: 0.24rem;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoInfo > p {
      margin-right: 0.3rem;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn {
      position: relative;
      user-select: none;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn .downLoadBox-container {
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 0.7rem;
      right: -2rem;
      z-index: 999;
      background: #FFF;
      padding: 0.2rem 0.34rem 0.2rem 0.34rem;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-box-shadow: 0rem 0rem 0.6rem 0px rgba(16,22,62,0.1);
      box-shadow: 0rem 0rem 0.6rem 0px rgba(16,22,62,0.1);
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn .downLoadBox-container .close {
      position: absolute;
      top: 0.2rem;
      right: 0.34rem;
      width: 0.2rem;
      height: 0.2rem;
      background: url('../assets/closeOn.png') no-repeat;
      background-position: center;
      background-size: 100%;
      cursor: pointer;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn .downLoadBox-container .close:hover {
      width: 0.2rem;
      height: 0.2rem;
      background: url('../assets/close.png') no-repeat;
      background-position: center;
      background-size: 100%;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn .downLoadBox-container > p {
      margin-bottom: 0.2rem;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn .downLoadBox-container > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      min-width: 4rem;
      margin-bottom: 0.2rem;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn .downLoadBox-container > div p {
      margin-right: 0.2rem;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn .downLoadBox-container span {
      font-size: 0.24rem;
      font-weight: 400;
      cursor: pointer;
      color: #1e69fe;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn .downLoadBox-container span:hover {
      color: #10163e;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn > p {
      float: left;
      width: 1.8rem;
      height: 0.6rem;
      line-height: 0.6rem;
      text-align: center;
      font-size: 0.28rem;
      border: 0.02rem solid #5e8df7;
      border-radius: 40px;
      color: #1e69fe;
      box-sizing: border-box;
      cursor: pointer;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn > p.on {
      width: 3.2rem;
      height: 0.6rem;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn > p:hover {
      border: 0.02rem solid #10163e;
      color: #10163e;
    }
    .header-container .video-container .leftVideo-container .leftTopVideo-container .videoInfo-container .videoBtn > p:nth-last-of-type(1) {
      margin-left: 0.2rem;
    }
    .header-container .video-container .leftVideo-container .unLogin-container {
      display: flex;
      flex-direction: row;
      width: 100%;
      min-height: 7.72rem;
      background: #FFF;
      font-size: 0.28rem;
      color: #10163e;
      box-shadow: 0rem 0.25rem 0.5rem 0px rgba(0,17,101,0.06);
      padding: 0.7rem 0.38rem 0.7rem;
      border: 1px solid #F5F5F6;
      box-sizing: border-box;
    }
    .header-container .video-container .leftVideo-container .unLogin-container p {
      font-size: 0.28rem;
      color: #1e69fe;
      margin: 0px 0.09rem;
      font-weight: bold;
      cursor: pointer;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container {
      position: relative;
      width: 100%;
      min-height: 7.72rem;
      background: #FFF;
      box-shadow: 0rem 0.25rem 0.5rem 0px rgba(0,17,101,0.06);
      padding: 0.36rem 0.4rem 0.5rem;
      border: 1px solid #F5F5F6;
      box-sizing: border-box;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container > p {
      user-select: none;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .clipeBox {
      position: absolute;
      top: -0.06rem;
      right: 0.55rem;
      background: #FFF;
      padding: 0.4rem 0.44rem 0.38rem 0.44rem;
      box-sizing: border-box;
      box-shadow: 0rem 0rem 0.6rem 0px rgba(16,22,62,0.1);
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .clipeBox div {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 0.26rem;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .clipeBox div p {
      font-size: 0.24rem;
      color: #848a9d;
      user-select: none;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .clipeBox div span {
      font-size: 0.28rem;
      color: #10163e;
      margin-left: 0.26rem;
      user-select: none;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .clipeBox div input {
      width: 3.72rem;
      height: 0.6rem;
      outline: none;
      border: 0.02rem solid #cfddfd;
      border-radius: 6px;
      box-sizing: border-box;
      margin-left: 0.23rem;
      font-size: 0.28rem;
      color: #10163e;
      padding: 0px 0.18rem;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .clipeBox .clipeBtn {
      display: flex;
      flex-direction: row;
      align-items: center;
      user-select: none;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .clipeBox .clipeBtn .cancel {
      width: 1.8rem;
      height: 0.6rem;
      line-height: 0.6rem;
      text-align: center;
      font-size: 0.28rem;
      color: #1e69fe;
      border: 0.02rem solid #5e8df7;
      border-radius: 40px;
      box-sizing: border-box;
      margin-left: 1.05rem;
      cursor: pointer;
      user-select: none;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .clipeBox .clipeBtn .submit {
      width: 1.8rem;
      height: 0.6rem;
      line-height: 0.6rem;
      text-align: center;
      font-size: 0.28rem;
      color: #FFF;
      background: linear-gradient(to right, #5e8df7 , #1e69fe);
      border-radius: 40px;
      box-sizing: border-box;
      margin-left: 0.2rem;
      cursor: pointer;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container > p {
      font-size: 0.32rem;
      color: #10163e;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .spliteTime {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 0.24rem;
      margin-bottom: 0.4rem;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .spliteTime > div {
      display: flex;
      flex-direction: row;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .spliteTime > div p {
      width: 1.8rem;
      height: 0.6rem;
      line-height: 0.6rem;
      text-align: center;
      border-radius: 6px;
      box-sizing: border-box;
      background: #e0e7ff;
      font-size: 0.28rem;
      color: #1e69fe;
      margin-right: 0.1rem;
      cursor: pointer;
      user-select: none;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .spliteTime > div input {
      width: 1.52rem;
      height: 0.6rem;
      line-height: 0.6rem;
      padding: 0px 0.18rem;
      font-size: 0.28rem;
      color: #10163e;
      outline: none;
      border: 0.02rem solid #cfddfd;
      border-radius: 6px;
      box-sizing: border-box;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .spliteTime > span {
      display: block;
      width: 0.4rem;
      height: 0.06rem;
      border-radius: 2px;
      box-sizing: border-box;
      background: #e0e7ff;
      margin: 0px 0.2rem;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .spliteBtn {
      display: flex;
      justify-content: center;
      width: 1.8rem;
      height: 0.6rem;
      line-height: 0.6rem;
      margin-left: 0.2rem;
      text-align: center;
      border-radius: 40px;
      font-size: 0.28rem;
      color: #FFF;
      background: linear-gradient(to right, #5086f9 , #2b70fd);
      cursor: pointer;
      user-select: none;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .spliteBtn.on {
      width: 3.4rem;
      height: 0.6rem;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .spliteBtn:hover {
      background: linear-gradient(to right, #1e69fe , #1e69fe);
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .line {
      width: 100%;
      height: 0.02rem;
      background: #e0e7ff;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container p {
      font-size: 0.32rem;
      color: #10163e;
      margin: 0.55rem 0 0.35rem 0;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container > p {
      user-select: none;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .hasMyVideo {
      margin: 0px;
      font-size: 0.28rem;
      color: #10163e;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 0.6rem;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li:nth-last-of-type(1) {
      margin-bottom: 0rem;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li img {
      width: 2.86rem;
      min-width: 2.86rem;
      height: 1.6rem;
      border-radius: 6px;
      box-sizing: border-box;
      margin-right: 0.18rem;
      user-select: none;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li .myVideoInfo-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex: 1;
      min-width: 0;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li .myVideoInfo-container .myVideoInfo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      min-width: 0;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li .myVideoInfo-container .myVideoInfo > p {
      margin: 0px;
      font-size: 0.28rem;
      line-height: 0.28rem;
      color: #10163e;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li .myVideoInfo-container .myVideoInfo .info {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li .myVideoInfo-container .myVideoInfo .info p {
      margin: 0px;
      font-size: 0.24rem;
      color: #848a9d;
      margin-right: 0.3rem;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li .myVideoInfo-container .myVideoBtn {
      position: relative;
      width: 2.68rem;
      height: 0.48rem;
      line-height: 0.48rem;
      text-align: center;
      font-size: 0.28rem;
      color: #1e69fe;
      border-radius: 40px;
      border: 0.02rem solid #5e8df7;
      z-index: 1;
      overflow: hidden;
      cursor: pointer;
      user-select: none;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li .myVideoInfo-container .myVideoBtn.on {
      position: relative;
      width: 3.68rem;
      height: 0.48rem;
      line-height: 0.48rem;
      text-align: center;
      font-size: 0.28rem;
      color: #1e69fe;
      border-radius: 40px;
      border: 0.02rem solid #5e8df7;
      z-index: 1;
      overflow: hidden;
      cursor: pointer;
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li .myVideoInfo-container .myVideoBtn:hover {
      color: #FFF;
      background: #1e69fe
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li .myVideoInfo-container .myVideoBtn p {
      position: absolute;
      top: 0px;
      left: 0px;
      /* width: 100%; */
      height: 100%;
      z-index: -1;
      background: #e0e7ff;
      margin: 0px;
      border-radius: 40px;
      animation: widthChange 2s infinite;
    }
    @keyframes widthChange {
      0%{
        width: 0%
      }
      100%{
        width: 100%
      }
    }
    .header-container .video-container .leftVideo-container .leftBottomVideo-container .myVideo-container .myVideo li .myVideoInfo-container .myVideoBtn:hover p {
      background: transparent
    }
    .header-container .video-container .rightVideo-container {
      width: 4.6rem;
      height: 18.4rem;
      overflow-y: scroll;
      /* min-height: 18.4rem; */
      padding: 0.3rem 0 0 0;
      background: #FFF;
      box-shadow: 0rem 0.25rem 0.5rem 0px rgba(0,17,101,0.06);
      border: 1px solid #F5F5F6;
      box-sizing: border-box;
    }
    .header-container .video-container .rightVideo-container::-webkit-scrollbar {/*滚动条整体样式*/
        width: 8px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 4px;
    }
    .header-container .video-container .rightVideo-container::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    .header-container .video-container .rightVideo-container.on::-webkit-scrollbar-track {/*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
    }
    .header-container .video-container .rightVideo-container::-webkit-scrollbar-track {/*滚动条里面轨道*/
        /* box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
        border-radius: 0;
        background: rgba(0,0,0,0);
    }
    .header-container .video-container .rightVideo-container ul {
      display: flex;
      flex-direction: row;
      padding: 0 0 0 0.3rem;
      font-size: 0.32rem;
      color: #848a9d;
    }
    .header-container .video-container .rightVideo-container > ul {
      position: relative;
      font-weight: bold;
    }
    .header-container .video-container .rightVideo-container ul.on {
      font-size: 0.28rem;
      padding: 0px;
    }
    .header-container .video-container .rightVideo-container ul li {
      position: relative;
      margin-right: 0.36rem;
      cursor: pointer;
      text-align: center;
      user-select: none;
      /* font-weight: bold; */
    }
    .header-container .video-container .rightVideo-container ul li.en {
      margin: 0px;
      width: 37%
    }
    .header-container .video-container .rightVideo-container ul p.en {
      width: 25%;
    }
    .header-container .video-container .rightVideo-container > ul p {
      position: absolute;
      right: 0px;
      top: 0.08rem;
      font-size: 0.24rem;
      font-weight: 400;
      cursor: pointer;
      color: #1e69fe;
      user-select: none;
      text-align: center;
    }
    .header-container .video-container .rightVideo-container > ul p:hover {
      color: #10163e;
    }
    .header-container .video-container .rightVideo-container ul li.on {
      color: #1e69fe;
    }
    .header-container .video-container .rightVideo-container ul li.on:after {
      display: block;
      content: '';
      position: absolute;
      bottom: -0.2rem;
      left: 50%;
      width: 0.4rem;
      height: 0.12rem;
      border-radius: 40px;
      background: #1e69fe;
      margin-left: -0.2rem;
    }
    .header-container .video-container .rightVideo-container .info {
      position: relative;
      padding: 0px 0 0 0.2rem;
      display: flex;
      flex-direction: row;
      box-sizing: border-box;
      margin-top: 0.6rem;
    }
    .header-container .video-container .rightVideo-container .info .info-container {
      display: flex;
      flex-direction: column;
    }
    .header-container .video-container .rightVideo-container .info .info-container p {
      font-size: 0.28rem;
      color: #10163e;
    }
    .header-container .video-container .rightVideo-container .info .info-container li {
      position: relative;
      display: flex;
      flex-direction: row;
      font-size: 0.24rem;
      line-height: 0.3rem;
      padding-bottom: 0.34rem;
      box-sizing: border-box;
      color: #10163e;
    }
    .header-container .video-container .rightVideo-container .info .info-container li .line {
      position: absolute;
      top: 0.1rem;
      left: -0.22rem;
      width: 0.04rem;
      height: 100%;
      background: #cfddfd;
    }
    .header-container .video-container .rightVideo-container .info .info-container li:nth-last-of-type(1) .line {
      position: absolute;
      top: 0.04rem;
      left: 0.28rem;
      width: 0rem;
      height: 0rem;
      background: #cfddfd;
    }
    .header-container .video-container .rightVideo-container .info .info-container li .date {
      margin-right: 0.2rem;
    }
    .header-container .video-container .rightVideo-container .info .info-container li .content {
      text-align: left;
    }
    .header-container .video-container .rightVideo-container .info .info-container li .point {
      position: absolute;
      top: 0.05rem;
      left: -0.3rem;
      width: 0.2rem;
      height: 0.2rem;
      border-radius: 50%;
      background: #cfddfd;
    }
    .header-container .video-container .rightVideo-container .info .info-container li .point:after {
      display: block;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -0.06rem;
      margin-left: -0.06rem;
      width: 0.12rem;
      height: 0.12rem;
      border-radius: 50%;
      background: #FFF;
    }
    .loadMore {
      display: flex;
      flex-direction: row;
      align-items: center;
      position: absolute;
      bottom: 0px;
      left: 50%;
      font-size: 0.28rem;
      color: #1e69fe;
      cursor: pointer;
    }
    .loadMore.down > i {
      width: 0.13rem;
      height: 0.17rem;
      background: url('../assets/leftArrowOn.png') no-repeat;
      background-size: 100%;
      background-position: center;
      transform: rotate(90deg);
      margin-right: 0.1rem;
    }
    .loadMore.down:hover > i {
      width: 0.13rem;
      height: 0.17rem;
      background: url('../assets/leftArrow.png') no-repeat;
      background-size: 100%;
      background-position: center;
      transform: rotate(90deg);
      margin-right: 0.1rem;
    }
    .loadMore.up > i {
      width: 0.13rem;
      height: 0.17rem;
      background: url('../assets/leftArrowOn.png') no-repeat;
      background-size: 100%;
      background-position: center;
      transform: rotate(-90deg);
      margin-right: 0.1rem;
    }
    .loadMore.up:hover > i {
      width: 0.13rem;
      height: 0.17rem;
      background: url('../assets/leftArrow.png') no-repeat;
      background-size: 100%;
      background-position: center;
      transform: rotate(-90deg);
      margin-right: 0.1rem;
    }
    .loadMore:hover {
      color: #10163e;
    }
    #hiddenUrl {
      position: absolute;
      top: -999999999px;
    }
</style>
<style>
  .xgplayer-progress-played {
    background-image: linear-gradient(-90deg,#F9496D,#F9496D) !important;
  }

  .xgplayer-progress:hover .xgplayer-progress-btn {
    width: 26px !important;
    height: 26px !important;
    background: url('../assets/point.png') no-repeat !important;
    background-size: 100% 100% !important;
    background-position: center center !important;
    top: -10px !important;
    z-index: 999999 !important;
  }

  .xgplayer-progress-btn {
    width: 26px !important;
    height: 26px !important;
    background: url('../assets/point.png') no-repeat !important;
    background-size: 100% 100% !important;
    background-position: center center !important;
    top: -12px !important;
    z-index: 999999 !important;
  }
  /* .xgplayer-progress-btn::after {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #F9496D;
  } */
  .timePoint-container {
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 999;
  }
  .timePoint-container div {
    position: absolute;
    width: 0.1rem;
    height: 0.32rem;
    background: url('../assets/videoPoint.png') no-repeat;
    background-size: 100%;
    background-position: center;
  }
  .timePoint-container div.startPoint {
    display: none;
    top: 50%;
    left: -0.05rem;
    z-index: 9;
    margin-top: -0.16rem;
  }
  .timePoint-container div.startPoint.on {
    display: block;
  }
  .timePoint-container div.endPoint {
    display: none;
    top: 50%;
    right: -0.05rem;
    z-index: 9;
    margin-top: -0.16rem;
  }
  .timePoint-container div.endPoint.on {
    display: block;
  }
  .timePoint-container div.startEndLine {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 0%;
    height: 100%;
    background: repeating-linear-gradient(-30deg,#3C78F9, #3C78F9 2px, #5086f9 0,#5086f9 4px);
  }
  .blockLine {
    position: relative;
    width: 100%;
    height: 4px;
    background: #000;
  }
  .block {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 16px;
    height: 16px;
    background: red;
  }
</style>
